<template>
    <button
        class="sub-button"
        :class="{'is-disabled':disabled}"
        :type="type"
        :disabled="disabled"
        @click="$emit('click')"
    ><slot></slot></button>
</template>

<script>
export default {
  name: "sub_button",
  props: {
    type: String,
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style scoped>
.sub-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  color: #fff;
  background-color: #20af0e;
  border-color: #20af0e;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  padding: 5px 20px;
  font-size: 16px;
  border-radius: 4px;
  width: 108px;
}
.is-disabled,
.is-disabled:focus,
.is-disabled:hover {
  color: #fff;
  background-color: #75b56c;
  border-color: #75b56c;
  cursor: not-allowed;
  pointer-events: none;
}
</style>